export const mergeBubbles = (bubbles: string[][], newBubble: string[]) => {
    if (!newBubble || newBubble.length === 0) {
        return bubbles.length > 0 ? bubbles : [[]];
    }

    const intersectingBubbles: string[][] = [];
    const nonIntersectingBubbles: string[][] = [];

    for (let bubbleIndex = 0; bubbleIndex < bubbles.length; bubbleIndex++) {
        const bubble = bubbles[bubbleIndex];

        let intersecting = false;
        for (const entry of newBubble) {
            if (bubble.includes(entry)) {
                intersectingBubbles.push(bubble);
                intersecting = true;
                break;
            }
        }

        if (!intersecting) {
            nonIntersectingBubbles.push(bubble);
        }
    }

    const newCommonBubble = [...intersectingBubbles.flat(), ...newBubble]
        .reduce((result, entry) => {
            if (!result.includes(entry)) {
                result.push(entry);
            }
            return result;
        }, [] as string[])
        .sort((entry1, entry2) => +entry1 - +entry2);

    return [...nonIntersectingBubbles, newCommonBubble].sort(
        (bubble1, bubble2) => +bubble1[0] - +bubble2[0],
    );
};
